import script from "./LabelRenameForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LabelRenameForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__